import { useSession } from '@components/app/Session';
import { FraudRiskLevel } from '@generated-types';

export const useIsHighFraudRisk = (): boolean => {
    const session = useSession();
    return session?.fraudRisk === FraudRiskLevel.HIGH;
};
